// src/api/company.js
// Wrappers for the company portal (role = company). The backend scopes every
// call to the admin's own company, so nothing here passes a company_id.
// Connect codes go through the shared /connect-codes route - a company-role
// user resolves to their company there automatically.
// Returns unwrapped data or throws { message, code, status }.

import client from "./client";
import { tokenStore } from "./client";

const unwrap = (res) => res.data.data;

const apiError = (err) => {
  const body = err.response?.data;
  const e = new Error(body?.error || "Something went wrong. Try again.");
  e.code = body?.code || "NETWORK";
  e.status = err.response?.status || 0;
  return e;
};

const run = async (promise) => {
  try {
    return unwrap(await promise);
  } catch (err) {
    throw apiError(err);
  }
};

// ---- profile + scan pool ------------------------------------------------
export const getCompany = () => run(client.get("/company"));
export const linkedUsers = () => run(client.get("/company/linked-users"));

// ---- claims board -------------------------------------------------------
export const listClaims = (status = "submitted") =>
  run(client.get("/company/claims", { params: { status } }));
export const getClaim = (id) => run(client.get(`/company/claims/${id}`));
export const payClaim = (id) => run(client.post(`/company/claims/${id}/paid`));
export const queryClaim = (id, note) => run(client.post(`/company/claims/${id}/query`, { note }));
export const rejectClaim = (id, note) =>
  run(client.post(`/company/claims/${id}/reject`, note ? { note } : {}));
export const getClaimMessages = (id) => run(client.get(`/company/claims/${id}/messages`));
export const sendClaimMessage = (id, body) => run(client.post(`/company/claims/${id}/messages`, { body }));

// authenticated proof-image URL (served by the API, company-scoped). Fetched as
// a blob with the bearer token - <img src> can't send the auth header.
export const claimItemImageUrl = (claimId, itemId) =>
  `${client.defaults.baseURL}/company/claims/${claimId}/items/${itemId}/image`;

// ---- connect codes (shared route; issuer resolved to this company) ------
export const listCodes = () => run(client.get("/connect-codes"));
export const issueCode = (body = {}) => run(client.post("/connect-codes", body));
export const revokeCode = (id) => run(client.post(`/connect-codes/${id}/revoke`));